const swiperConfig = {
    cssMode: true,
    slidesPerView: 1,
    pagination: {
        el: '.products-item-gallery__pagination',
        bulletClass: 'products-item-gallery__pagination-bullet',
        bulletActiveClass: 'products-item-gallery__pagination-bullet_active',
        dynamicBullets: true,
        dynamicMainBullets: 5,
        clickable: true
    },
    lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
        elementClass: 'swiper-lazy'
    }
}

const $window = $(window);

const productGallery = Component(($context) => $context.find('.products-item-gallery'), ($gallery) => {
    const swiper = new Swiper($gallery.find('.swiper').get(0), swiperConfig);

    function galleryType(width) {
        if (width < 900) {
            $gallery.removeClass('products-item-gallery_d');
            $gallery.addClass('products-item-gallery_m');
            $gallery.off('mouseenter');
            $gallery.off('mouseout');
            return;
        }

        $gallery.removeClass('products-item-gallery_m');
        $gallery.addClass('products-item-gallery_d');

        $gallery.on('mouseenter', '.products-item-gallery__field-item', function () {
            const index = $(this).data('index');
            $gallery.find('.products-item-gallery__pagination-bullet').eq(index).addClass('products-item-gallery__pagination-bullet_active')
            swiper.slideTo(index);
        });

        $gallery.on('mouseout', '.products-item-gallery__field-pagination', function () {
            $gallery.find('.products-item-gallery__pagination-bullet').eq(0).addClass('products-item-gallery__pagination-bullet_active')
            swiper.slideTo(0);
        });
    }

    galleryType($window.width())

    $window.on('resize', function () {
        const width = $window.width();
        const changeGalleryType = (width > 900 && $gallery.hasClass('products-item-gallery_m'))
            || (width < 900 && $gallery.hasClass('products-item-gallery_d'))

        if (changeGalleryType) {
            galleryType(width);
        }
    })
})

ObserverUtil.observeComponent('products-item-gallery', productGallery);